export default "__VITE_ASSET__125387c9__"